import styled from 'styled-components';
import { BodyMedium, ButtonOutlineLarge, DividerBlueStyled as DividerBlueStyledBase, H3 } from '@styled';
import { breakpointNumbers, mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';

export const BodyContainerStyled = styled.div`
    padding-top: 34px;

    @media print {
        padding-bottom: 0;
        padding-top: 0;
    }

    @media (max-width: ${breakpointNumbers.medium - 1}px) {
        padding-bottom: 28px;
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 28px;
    }
`;

export const GridContainerStyled = styled.div`
    @media print {
        display: block;
    }

    @media ${mediaQueries.md} {
        display: grid;
        grid-template-columns: repeat(8, 1fr);
        grid-column-gap: 35px;
    }
`;

export const ViewReceiptButtonStyled = styled(ButtonOutlineLarge)`
    display: flex;
    align-items: center;

    svg path {
        fill: ${colors.azure};
        transition: fill 0.2s ease-in-out;
    }

    &:hover {
        svg path {
            fill: ${colors.white};
        }
    }
`;

export const OrderReceiptContainerStyled = styled.div`
    display: ${props => (props.visible ? 'block' : 'none')};
    margin-top: 60px;

    @media print {
        display: block;
        margin-top: 40px;
    }
`;

export const DividerBlueStyled = styled(DividerBlueStyledBase)`
    @media print {
        border-color: ${colors.lightGray};
        border-top-width: 1px;
    }
`;

export const NwpCtaContainerStyled = styled.div`
    margin-top: 130px;

    @media print {
        display: none;
    }

    @media ${mediaQueries.md} {
        margin-bottom: 34px;
        margin-top: 200px;
    }
`;
